import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import { colors } from '../../primitives/colors';
import Link from '../../primitives/link';
import Typography from '../../primitives/typography';
import paddingDefault from '../../utils/padding-default';
import Container from '../../primitives/grid/container';

const ServiceArea: React.FC<Queries.ServiceAreaDataFragment> = (data) => {
    const { title } = data || {};

    const {
        franchise,
    } = useMicrosite();

    if (!franchise) return null;

    const { activeMarkets } = franchise;

    if (!!activeMarkets && activeMarkets?.length > 0) {
        return (
            <Container css={paddingDefault(null, true)}>
                <Typography
                    as="h4"
                    fontSize={{
                        dt: '2xl',
                        mb: 'xl',
                    }}
                    css={{
                        marginBottom: '12px',
                    }}
                >
                    {title}
                </Typography>
                <Typography fontSize={{
                    dt: 'lg',
                    mb: 'base',
                }}
                >
                    {activeMarkets.map((activeMarket, idx) => {
                        const { city, state } = activeMarket;
                        const place = [city, state].filter(x => !!x).join(', ');
                        const uniqueKey = `${city || 'unknown'}-${state || 'unknown'}-${activeMarket.link || 'no-link'}`;

                        if (activeMarket.link) {
                            return (
                                <span key={uniqueKey}>
                                    <Link
                                        css={{
                                            textDecoration: 'underline',
                                            transition: '0.3s',
                                            '&:hover': {
                                                color: colors.primaryGreen,
                                            },
                                        }}
                                        to={(activeMarket.link || '')}
                                    >
                                        {place}
                                    </Link>
                                    {idx !== activeMarkets.length - 1 && ' | '}
                                </span>
                            );
                        }

                        return (
                            <span key={uniqueKey}>
                                {place}
                                {idx !== activeMarkets.length - 1 && ' | '}
                            </span>
                        );
                    })}
                </Typography>
            </Container>
        );
    }

    return null;
};

export const query = graphql`
    fragment ServiceAreaData on CsServiceAreaGroup {
        title
    }
`;

export default ServiceArea;
